<template>
    <div class="ribs-form">
        Make ribs:
        <button @click="decrease" title="decrease">-</button>
        <input type="text" :value="count" @input="setCount">
        <button @click="increase" title="increase">+</button>

        <div v-if="count">
            <br>
            <span class="no-wrap">Starting length: {{ lineStartingLength }} &nbsp;(<b>{{ getFootsInFractions(lineStartingLength) }}"</b>)</span>
            <br>
            <span class="no-wrap">Ending length: {{ lineEndingLength }} &nbsp;(<b>{{ getFootsInFractions(lineEndingLength) }}"</b>)</span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "LineRibsForm",

        emits: [
            'setCount',
        ],

        props: [
            'lineStartingLength',
            'lineEndingLength',
            'ribsCount',
        ],

        data() {
            return {
                count: 0,
            }
        },

        computed: {
            ...mapGetters('editor', [
                'getFootsInFractions',
            ]),

        },

        methods: {
            decrease() {
                if (this.count <= 0) return;

                this.count -= 1;

                this.emitData();
            },

            increase() {
                // the rib length is 1"
                // check if the line can contain this ribs count
                if (this.count >= this.lineEndingLength - 1) return;

                this.count += 1;

                this.emitData();
            },

            setCount(e) {
                this.count = +e.target.value;

                this.emitData();
            },

            emitData() {
                this.$emit('setCount', this.count);
            },

        },

        beforeMount() {
            // initialize ribs count value
            this.count = +this.ribsCount || 0;
        },

    }
</script>

<style scoped>
    .ribs-form {
        margin: 8px 0;
    }

    button {
        width: 24px;
        margin: 0 5px;
    }

    input {
        width: 30px;
    }
</style>